<template>
  <div class="ota-app">
    <header-navigation v-if="showHeader" :logo="false" :hide-header="!isBw && showHeader" />
    <form-error
      v-if="globalError"
      class="global-warning"
      :errors="globalError"
      :dismissible="true"
      @dismissed="clearGlobalError"
    />
    <router-view :key="reloadKey" @changeLocale="changeLocale" />
  </div>
</template>

<script>
import changeLocaleMixin from 'mixins/changeLocaleMixin'
import triplaLocalStorage from 'utilities/triplaLocalStorage'
import _isEmpty from 'lodash/isEmpty'
import PATH from 'routes/paths'
import HeaderNavigation from 'components/Navigation'
import { mapGetters, mapActions } from 'vuex'
import { ReservationStep } from './constants/reservation'
import FormError from 'components/FormError'

export default {
  name: 'OtaApp',
  components: {
    HeaderNavigation,
    FormError
  },
  mixins: [changeLocaleMixin],
  metaInfo() {
    const defaultMetaInfo = {
      meta: [
        {
          name: 'robots',
          content: this.$route.name === PATH.ota.home ? 'index, follow' : 'noindex, nofollow'
        },
        {
          name: 'msapplication-TileColor',
          content: '#da532c'
        },
        {
          name: 'theme-color',
          content: '#ffffff'
        }
      ],
      link: [
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
        { rel: 'manifest', href: '/site.webmanifest' },
        { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#c21e58' }
      ]
    }

    if (this.$route.meta.pageTitle) {
      const hotelName = this.$store.getters['setting/getHotelName']
      defaultMetaInfo.title =
        'tripla | ' +
        (this.$route.meta.noHotelCode ? '' : `${hotelName || '~'} | `) +
        this.$t(`meta.${this.$route.meta.pageTitle}`, this.$i18n.locale)
    }

    if (this.$route.name === PATH.ota.home) {
      defaultMetaInfo.meta.push({
        name: 'description',
        content: this.$t('meta.otaHomeDescription')
      })
    }

    return defaultMetaInfo
  },
  provide() {
    return { changeLocale: this.changeLocale }
  },
  computed: {
    ...mapGetters({
      isMcpEnabled: 'mcp/isMcpEnabled',
      globalError: 'error/getGlobalError'
    }),
    isBw() {
      return false
    },
    showHeader() {
      const currentStep = this.$store.getters['booking/getCurrentStep']
      const currentRouteName = this.$route.name
      const hasKeyQuery = !!this.$route.query.key

      const shouldShowGuestDetail = currentStep === ReservationStep.Payment

      const displayPages = [
        ...(shouldShowGuestDetail ? [PATH.reservation.guestDetail] : []),
        ...(hasKeyQuery ? [PATH.ota.reservation.payment] : [])
      ]
      const isCurrentPageDisplay = displayPages.includes(currentRouteName)
      return this.isMcpEnabled && isCurrentPageDisplay
    }
  },
  created() {
    this.checkLocale()
  },
  mounted() {
    document.documentElement.style.setProperty('--theme-btn-color', '#C21E58')
    document.documentElement.style.setProperty('--theme-font-color', '#fff')
  },
  methods: {
    ...mapActions({ clearGlobalError: 'error/clearGlobalError' }),
    checkLocale() {
      const currentLang = triplaLocalStorage.getItem('triplabot_locale')

      if (currentLang) return

      const localeFromQuery = this.$route.query.locale
      if (localeFromQuery) {
        this.changeLocale(localeFromQuery)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/mixins.scss';
.global-warning {
  width: 60%;
  position: fixed;
  top: 8px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 104;
  animation: fixedfadeDown 0.5s;
}
@include media-breakpoint-down(md) {
  .global-warning {
    width: 100%;
  }
}
@keyframes fixedfadeDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
